import { takeLatest, put, call } from 'redux-saga/effects';
import { storage } from '@commons/storage';
import {
  CONFIG_SESSION,
  NEW_FILTER_FORNECEDOR_CADASTRO,
  NEW_FILTER_FORNECEDOR_CADASTRO_PENDING,
  NEW_FILTER_FORNECEDOR_CADASTRO_SUCCESS,
  NEW_FILTER_FORNECEDOR_CADASTRO_FAILURE,
} from '@handler';
import { filterFornecedorCadastro } from '../service';
import { CONST_FILTER_FORNECEDOR_CADASTRO, CONST_ROWS_PER_PAGE } from '@commons/consts';

function* sagaNewFilterFornecedorCadastro(action) {
  try {
    yield put({ type: NEW_FILTER_FORNECEDOR_CADASTRO_PENDING });
    const idFazenda = JSON.parse(storage.get(CONFIG_SESSION)).fazendaSelecionada.id;

    let where = '';
     let filterSaved = sessionStorage.getItem(CONST_FILTER_FORNECEDOR_CADASTRO) !== null ? JSON.parse(sessionStorage.getItem(CONST_FILTER_FORNECEDOR_CADASTRO)) : null;
    let newFilter = {
      nome: '',
      fantasia: '',
      ativo: "S",
      tipoPessoa: null,
      cpf: '',
      cnpj: '',
      rows: filterSaved?.rows || CONST_ROWS_PER_PAGE,
      page: filterSaved?.page || 0,
      where: ''
    };
    
    if (filterSaved === null || filterSaved === undefined) {
      newFilter = {
        ...newFilter,
      };
    } else {
      // se seta filtro manual
      if (action.newFilter) {
        // Quando aplica um novo filtro, volta para a primeira página
        // mas mantém o número de registros por página selecionado pelo usuário
        newFilter.page = 0;

        // seta filtro indicado
        if (action.args.ativo !== null) {
          where += `&ativo=${action.args.ativo === 'S' ? true : false}`;
        }
        if (action.args.nome !== null && action.args.nome !== '') {
          where += `&nome=${action.args.nome}`;
        }
        if (action.args.fantasia !== null && action.args.fantasia !== '') {
          where += `&apelido=${action.args.fantasia}`;
        }

        if (action.args.tipoPessoa) {
          where += `&tipoPessoa=${action.args.tipoPessoa}`;
          if (action.args.tipoPessoa === 'FISICA' && action.args.cpf)
            where += `&cpf=${action.args.cpf}`;
          if (action.args.tipoPessoa === 'JURIDICA' && action.args.cnpj)
            where += `&cnpj=${action.args.cnpj}`;
        }
        
        newFilter = {
          ...newFilter,
          ...action.args,
          where: where
        };
      } else {
        // busca filtro salvo
        if (filterSaved.ativo !== null) {
          where += `&ativo=${filterSaved.ativo === 'S' ? true : false}`;
        }
        if (filterSaved.nome !== null && filterSaved.nome !== '') {
          where += `&nome=${filterSaved.nome}`;
        }
        if (filterSaved.fantasia !== null && filterSaved.fantasia !== '') {
          where += `&apelido=${filterSaved.fantasia}`;
        }

        if (filterSaved.tipoPessoa) {
          where += `&tipoPessoa=${filterSaved.tipoPessoa}`;
          if (filterSaved.tipoPessoa === 'FISICA' && filterSaved.cpf)
            where += `&cpf=${filterSaved.cpf}`;
          if (filterSaved.tipoPessoa === 'JURIDICA' && filterSaved.cnpj)
            where += `&cnpj=${filterSaved.cnpj}`;
        }

        newFilter = {
          ...filterSaved,
          where: where
        };
      }
    }
    
    // busca registros
    const list = yield call(filterFornecedorCadastro, idFazenda, `&page=${newFilter.page}&size=${newFilter.rows}${where}`);
    sessionStorage.setItem(CONST_FILTER_FORNECEDOR_CADASTRO, JSON.stringify(newFilter));
    
    yield put({
      type: NEW_FILTER_FORNECEDOR_CADASTRO_SUCCESS, list: list, filter: newFilter
    });
  } catch (_) {
    yield put({ type: NEW_FILTER_FORNECEDOR_CADASTRO_FAILURE })
  }
}

export default function* watchNewFilterFornecedorCadastro() {
  yield takeLatest(NEW_FILTER_FORNECEDOR_CADASTRO, sagaNewFilterFornecedorCadastro)
}